//所有有关用户信息的网络请求
import http from '../utils/http'

  
  //新增
export function apiAddAutoLoginList(data){
    return http({
      url:'/client/buyOrder/unlimited',
      method:'post',
      data
    })
  }
  
  //编辑
  export function apiEditAutoLoginList({id,data}){
    return http({
      url:`/client/buyOrder/${id}`,
      method:'put',
      data
    })
  }

  //删除
  export function apiDeleteAutoLoginList(id) {
    return http({
      url: `/client/buyOrder/${id}`,
      method: "delete",
    });
  }

  //多条件分页查询
export function apiAutoLoginSearch(params) {
  return http({
    url: `/client/buyOrder`,
    method: "get",
    params:params,
  });
}

//导入
export function apiImportFile(params){
  return http({
    url:'/client/buyOrder/upload',
    method:'post',
    data:params,
    headers:{
      'content-type':'multipart/form-data'
    }
  })
}

// 导出用户自助登记表
export function buyOrderExport(params){
  return http({
    url:`/client/buyOrder/download`,
    method:'get',
    params:params,
    responseType: 'blob'
  })
}


  